import gql from 'graphql-tag'
import { AggregatePath } from '@/entities/interfaces'
import { ClosingReasonFragment } from '@/graphql/fragments/settings'

const structure: Array<AggregatePath> = [
  { name: 'sales', title: 'Sales', aggregations: ['count'] },
]
const query = gql`
  ${ClosingReasonFragment}
  query aggregates($model: settings_closing_reason_bool_exp, $aggregate: sales_sale_order_bool_exp, $order: [settings_closing_reason_order_by!]) {
    aggregates: settings_closing_reason(where: $model, order_by: $order) {
      ...ClosingReason
      sales: sale_orders_aggregate(where: $aggregate) {
        aggregate {
          count(distinct:true)
        }
      }
    }
  }
`
export const aggregate = { structure, query }
export default aggregate
